import { Field, Label, Switch } from '@headlessui/react';
import React, { useMemo, useState } from 'react';

import { DemoHabitCheckTracker } from '../app/components/Habits/DemoHabitCheckTracker';
import { generateDemoHabit } from '../app/components/Habits/habitUtils';
import {
  defaultTheme,
  getThemeById,
} from '../app/components/Habits/utils/HabitCheckTrackerThemes';
import { ThemeSelector } from '../app/components/ThemeSelector';
import OptionsCan from '../images/130.svg';
import Title from './elements/Title';
import NotionPreview from './NotionPreview';

interface OptionsProperties {
  name?: string;
}

const Options: React.FC<OptionsProperties> = ({ name = 'Your Name' }) => {
  const [icons, setIcons] = useState(false);
  const [header, setHeader] = useState(false);
  const [skip, setSkip] = useState(false);

  const [currentThemeId, setCurrentThemeId] = useState('notion-light-blue');

  const [walkingHabit] = useState(
    generateDemoHabit('accessibility_sport', 'Sport', 300)
  );

  const setIconsHandler = (value: boolean) => {
    console.log('setIconsHandler', value);
    console.log('setIconsHandler', currentThemeId);
    setIcons(value);
    if (value && !currentThemeId.includes('-with-icon')) {
      console.log('scenario 1', currentThemeId);
      setCurrentThemeId(currentThemeId + '-with-icon');
    }
    if (!value && currentThemeId.includes('-with-icon')) {
      console.log('scenario 2', currentThemeId);
      setCurrentThemeId(currentThemeId.replace('-with-icon', ''));
    }
  };

  const currentTheme = useMemo(
    () => getThemeById(currentThemeId),
    [currentThemeId, icons]
  );

  return (
    <div className="mx-0 mt-6 flex w-full flex-col items-center gap-6 bg-[#f5f3f2] p-6 sm:mx-2 sm:rounded-xl md:mt-24 md:p-12 lg:mx-0">
      <div className="w-20">
        <img
          loading="lazy"
          width={80}
          height={80}
          src={OptionsCan.src}
          alt="Switchs"
        />
      </div>
      <Title color="orange">Choose your options</Title>
      <div className="leading-relaxed">
        Add icons, add the ability to skip, and even the number of consecutive
        days.
      </div>
      <div className="flex flex-row gap-6">
        <div className="flex flex-row items-center gap-1.5">
          <Field className="flex flex-row items-center gap-1">
            <Switch
              aria-label="Show icons"
              checked={icons}
              onChange={setIconsHandler}
              className="group inline-flex h-6 w-11 items-center rounded-full bg-black transition data-[checked]:bg-blue-600"
            >
              <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
            </Switch>
            <Label>Icons</Label>
          </Field>
        </div>
        <div className="flex flex-row items-center gap-1.5">
          <Field className="flex flex-row items-center gap-1">
            <Switch
              aria-label="Show header"
              checked={header}
              onChange={setHeader}
              className="group inline-flex h-6 w-11 items-center rounded-full bg-black transition data-[checked]:bg-blue-600"
            >
              <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
            </Switch>
            <Label>Header</Label>
          </Field>
        </div>
        <div className="flex flex-row items-center gap-1.5">
          <Field className="flex flex-row items-center gap-1">
            <Switch
              aria-label="Can skip"
              checked={skip}
              onChange={setSkip}
              className="group inline-flex h-6 w-11 items-center rounded-full bg-black transition data-[checked]:bg-blue-600"
            >
              <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
            </Switch>
            <Label>Skip</Label>
          </Field>
        </div>
      </div>

      <div className="mb-3 flex w-full max-w-[570px] flex-col">
        <ThemeSelector
          themeId={currentTheme.id || defaultTheme}
          onThemeChange={(themeId) => {
            setCurrentThemeId(themeId);
          }}
          canSkip={skip}
          showFilters={false}
          showDemoType={icons ? 'options-with-icons' : 'options-without-icons'}
        />
      </div>
      <NotionPreview name={name} darkMode={currentTheme.scheme === 'dark'}>
        <div className=" mt-6 flex h-full flex-col  ">
          <DemoHabitCheckTracker
            habit={walkingHabit}
            theme={currentTheme}
            height={150}
            canSkip={skip}
            showHeader={header}
          />
        </div>
      </NotionPreview>
    </div>
  );
};

export default Options;
